<template>
  <nav class="sa-rep-pagination" aria-label="Paginação">
    <template v-if="totalPages > 1">
      <button
        type="button"
        class="sa-rep-pagination__btn"
        :disabled="page <= 1"
        aria-label="Página anterior"
        @click="$emit('update:page', page - 1)"
      >
        ‹
      </button>

      <button
        v-for="item in pageItems"
        :key="`p-${item.key}`"
        type="button"
        class="sa-rep-pagination__btn"
        :class="{
          active: item.page === page,
          ellipsis: item.type === 'ellipsis',
        }"
        :disabled="item.type === 'ellipsis'"
        :aria-current="item.page === page ? 'page' : undefined"
        @click="item.type === 'page' && $emit('update:page', item.page)"
      >
        {{ item.label }}
      </button>

      <button
        type="button"
        class="sa-rep-pagination__btn"
        :disabled="page >= totalPages"
        aria-label="Próxima página"
        @click="$emit('update:page', page + 1)"
      >
        ›
      </button>
    </template>

    <label class="sa-rep-pagination__size">
      <span class="sr-only">Itens por página</span>
      <select
        :value="pageSize"
        @change="$emit('update:pageSize', Number($event.target.value))"
      >
        <option :value="10">10 por página</option>
        <option :value="20">20 por página</option>
        <option :value="50">50 por página</option>
      </select>
    </label>
  </nav>
</template>

<script>
export default {
  name: 'ReportsPagination',
  props: {
    page: { type: Number, required: true },
    totalPages: { type: Number, required: true },
    pageSize: { type: Number, default: 20 },
  },
  emits: ['update:page', 'update:pageSize'],
  computed: {
    pageItems() {
      const total = this.totalPages;
      const current = this.page;
      if (total <= 7) {
        return Array.from({ length: total }, (_, i) => ({
          type: 'page',
          page: i + 1,
          label: String(i + 1),
          key: `page-${i + 1}`,
        }));
      }

      const pages = new Set([1, total, current, current - 1, current + 1]);
      const sorted = [...pages].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
      const items = [];
      let prev = 0;
      sorted.forEach((p) => {
        if (prev && p - prev > 1) {
          items.push({ type: 'ellipsis', label: '…', key: `e-${prev}-${p}` });
        }
        items.push({ type: 'page', page: p, label: String(p), key: `page-${p}` });
        prev = p;
      });
      return items;
    },
  },
};
</script>

<style scoped>
.sa-rep-pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.85rem;
}

.sa-rep-pagination__btn {
  min-width: 2rem;
  height: 2rem;
  border: 1px solid var(--dashboard-border, #e8eaf0);
  background: #fff;
  border-radius: 8px;
  color: var(--dashboard-text, #191c24);
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
}

.sa-rep-pagination__btn:hover:not(:disabled):not(.ellipsis) {
  background: #f8f9fc;
}

.sa-rep-pagination__btn.active {
  background: var(--dashboard-primary, #250891);
  border-color: var(--dashboard-primary, #250891);
  color: #fff;
}

.sa-rep-pagination__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.sa-rep-pagination__btn.ellipsis {
  border-color: transparent;
  background: transparent;
  cursor: default;
}

.sa-rep-pagination__size {
  margin-left: auto;
}

.sa-rep-pagination__size select {
  height: 2rem;
  border: 1px solid var(--dashboard-border, #e8eaf0);
  border-radius: 8px;
  background: #fff;
  padding: 0 0.5rem;
  font-size: 0.75rem;
  color: var(--dashboard-muted, #697386);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
